import * as types from './types';

type Action = {
    type: keyof typeof types;
    payload?: { error?: string | null };
};

export default function (state: string | null = null, action: Action): string | null {
    switch (action.type) {
        case types.SESSION_SIGNED_OUT:
        case types.SESSION_ERROR:
            return action.payload?.error ?? null;

        case types.SESSION_SIGNED_IN:
        case types.SESSION_ACCOUNT_LOADED:
        case types.SESSION_ACCOUNT_UPDATED:
        case types.SESSION_ACCOUNT_PASSWORD_CHANGED:
        case types.SESSION_ERROR_CLEARED:
            return null;

        default:
            return state;
    }
}
